import {Grid, MenuItem, Select, TextField} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";
import {CategoryTree, createCategory, deleteCategory, updateCategory} from "../repository/CategoryTree.repo";
import CategorySelectBox from "./CategorySelectBox";
import ViewBox from "./ViewBox";
import AvailableLanguages from "../availableLanguages";
import LanguageTab from "../LanguageTab";

type Props = {
    category?: CategoryTree
    categories: CategoryTree[];
    currentParent?: number | null;
    onUpdate: (ID?: number) => void;
    setIsLoading: (status: boolean) => void;
}

export default function CategoryForm(props: Props){

    const [formState, setFormState] = useState<CategoryTree>({
        Name: '',
        ParentID: 0,
        Description: '',
        Tags: '',
        ID: 0,
    });


    const [languageState, setLanguageState] = useState<{[key: string]: CategoryTree}>({})

    const [editingLanguage, setEditingLanguage] = useState('de');


    const create = useCallback(async () => {
        props.setIsLoading(true);
        const d = await createCategory(formState, languageState)
        console.log(d);
        props.setIsLoading(false);
        props.onUpdate(d.ID);
    }, [formState, props, languageState]);

    const update = useCallback(async () => {
        props.setIsLoading(true);
        const u = await updateCategory(formState, formState.ID, languageState);
        props.setIsLoading(false);
        props.onUpdate();
        console.log(u);
    }, [formState, props, languageState]);


    useEffect(() => {

        const {category} = props;

        if(category === undefined){
            setFormState({
                Name: '',
                ParentID: Number(props.currentParent),
                Description: '',
                Tags: '',
                ID: 0,
            });
            return;
        }


        setFormState({
            Name: category.Name,
            ParentID: category.ParentID,
            Description: category.Description,
            Tags: category.Tags,
            ID: category.ID,
        });

        if(category.CategoryTreeLanguage !== undefined){
            if(category.CategoryTreeLanguage.length > 0){

                const obj = {};

                category.CategoryTreeLanguage.forEach((item) => {
                    //@ts-ignore
                    obj[item.lang] = {
                        Name: item.Name,
                        Description: item.Description,
                        Tags: item.Tags,
                    }
                });

                setLanguageState({...obj})

            }
        }



    }, [props.category]);


    const removeCategory = useCallback(async () => {

        if(props.category === undefined){
            return;
        }
        props.setIsLoading(true);
        const remove = await deleteCategory(props.category.ID);
        props.setIsLoading(false);
        props.onUpdate(-1);
    }, [props]);

    // const onChangeCategory = useCallback((p: any, s: any) => {
    //     console.log(s)
    // }, []);

    return (
        <ViewBox title={props.category !== undefined ? 'Update Category' : "Create Category"} width={50} rightComponent={
            <div  style={{ display: 'flex', flexDirection: 'row' }}>
                <div onClick={props.category !== undefined ? update : create} style={{ backgroundColor: 'green', height: 40, width: 120, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', borderRadius: 8 }}> Speichern</div>
                {props.category !== undefined && <div onClick={removeCategory} style={{ backgroundColor: 'red', height: 40, width: 120, marginLeft: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', borderRadius: 8 }}> Löschen</div>}
            </div>
        }>

            <LanguageTab activeLanguage={editingLanguage} onChange={setEditingLanguage} />

            <Grid style={{marginTop: 0}} container spacing={2}>
                <Grid item md={12} direction="row" gridAutoRows={2}>
                    <ViewBox>
                        <TextField
                            onChange={(e) => {
                                if(editingLanguage === 'de'){
                                    setFormState({...formState, Name: e.target.value})
                                }else{
                                    if(languageState[editingLanguage] !== undefined){
                                        languageState[editingLanguage] = {...languageState[editingLanguage], Name: e.target.value}
                                    }else{
                                        //@ts-ignore
                                        languageState[editingLanguage] = { Name: e.target.value}
                                    }
                                    setLanguageState({...languageState});
                                }
                            }}
                            id="outlined-basic" label="Name"
                            key={languageState[editingLanguage] + 'name'}
                            defaultValue={editingLanguage === 'de' ? formState.Name : (languageState[editingLanguage]?.Name ?? '')}
                            value={editingLanguage === 'de' ? formState.Name : (languageState[editingLanguage]?.Name ?? '')} style={{marginTop: 10}} variant="outlined" />
                    </ViewBox>
                    <ViewBox>
                        <TextField
                            onChange={(e) => {
                                if(editingLanguage === 'de'){
                                    setFormState({...formState, Tags: e.target.value})
                                }else{
                                    if(languageState[editingLanguage] !== undefined){
                                        languageState[editingLanguage] = {...languageState[editingLanguage], Tags: e.target.value}
                                    }else{
                                        //@ts-ignore
                                        languageState[editingLanguage] = {Tags: e.target.value}
                                    }
                                    setLanguageState({...languageState});
                                }

                            }}
                            id="outlined-basic"  style={{marginTop: 10}}
                            value={editingLanguage === 'de' ? formState.Tags : (languageState[editingLanguage]?.Tags ?? '')}
                            defaultValue={editingLanguage === 'de' ? formState.Tags : (languageState[editingLanguage]?.Tags ?? '')}
                            label="Tags"
                            key={languageState[editingLanguage] + 'tags'}
                            variant="outlined" />

                    </ViewBox>
                    <ViewBox>
                        <TextField
                            onChange={(e) => {
                                if(editingLanguage === 'de'){
                                    setFormState({...formState, Description: e.target.value})
                                }else{
                                    if(languageState[editingLanguage] !== undefined){
                                        languageState[editingLanguage] = {...languageState[editingLanguage], Description: e.target.value}
                                    }else{
                                        //@ts-ignore
                                        languageState[editingLanguage] = {Description: e.target.value}
                                    }
                                    setLanguageState({...languageState});
                                }
                            }}
                            id="outlined-basic"
                            style={{marginTop: 10}}
                            key={languageState[editingLanguage] + 'description'}
                            defaultValue={editingLanguage === 'de' ? formState.Description : (languageState[editingLanguage]?.Description ?? '')}
                            value={editingLanguage === 'de' ? formState.Description : (languageState[editingLanguage]?.Description ?? '')}
                            label="Description"
                            variant="outlined"
                        />

                    </ViewBox>
                </Grid>
                <Grid item md={12} direction="row" gridAutoRows={2}>
                {/*<ViewBox title="Parent Category">*/}
                {/*    <CategorySelectBox categories={props.categories} onChange={onChangeCategory} />*/}
                {/*</ViewBox>*/}
                </Grid>

            </Grid>
        </ViewBox>

    )

}
